import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';

@Injectable()
export class NoGuard implements CanActivate {

  constructor() {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return true;
  }
}
